// 轻量线性图标（stroke 风格），替代导航里的 emoji
const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function IconHome(p) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...p}>
      <path d="M3 10.8 12 3.5l9 7.3" />
      <path d="M5.5 9.4V20h13V9.4" />
      <path d="M10 20v-5.5h4V20" />
    </svg>
  );
}

export function IconTimer(p) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...p}>
      <circle cx="12" cy="13" r="8" />
      <path d="M12 9v4l2.6 2.6" />
      <path d="M9.5 2.5h5" />
    </svg>
  );
}

export function IconChart(p) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...p}>
      <path d="M4 20V10" />
      <path d="M10 20V4" />
      <path d="M16 20v-7" />
      <path d="M3 20h18" />
    </svg>
  );
}

export function IconUsers(p) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...p}>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M3.5 20c.8-3.6 3-5.2 5.5-5.2s4.7 1.6 5.5 5.2" />
      <circle cx="17" cy="9.5" r="2.8" />
      <path d="M15.6 15.2c2 .5 3.5 1.8 4.2 4.3" />
    </svg>
  );
}

export function IconGear(p) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...p}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.2 5.2l2.1 2.1M16.7 16.7l2.1 2.1M18.8 5.2l-2.1 2.1M7.3 16.7l-2.1 2.1" />
    </svg>
  );
}

export function IconWarn(p) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...p}>
      <path d="M12 3.5 22 20H2L12 3.5Z" />
      <path d="M12 10v4" />
      <path d="M12 17h.01" />
    </svg>
  );
}
